<template>
  <div class="contact" id="contact">
    <DirectionArrows :position="$props.position" :count="$props.count" :sidebar="$props.sidebar"/>

    <HelloWorld msg="Contact"/>
    <div v-if="!isSend"class="form-container">
      <div v-if="errorMessage" class="error-message">{{errorMessage}}</div>

      <form action="" @submit="validate" >
        <div class="label-group">
          <label for="name">Prénom :</label>
          <input v-model="name" type="text" name="name" id="name" required>
        </div>
        <div class="label-group">
          <label for="lastname">Nom :</label>
          <input v-model="lastname" type="text" name="lastname" id="lastname" required>
        </div>
        <div class="label-group">
          <label for="mail">Mail :</label>
          <input v-model="mail" type="email" name="mail" id="mail" required>
        </div>
        <div class="label-group">
          <label for="subject">Sujet :</label>
          <input v-model="sujet" type="text" name="subject" id="subject" required>
        </div>
        <div class="label-group">

          <textarea v-model="message" rows="10" name="message" id="message" placeholder="Dites m'en plus ..." required/>
        </div>

        <div class="submit-group">

          <button type="submit" class="btn">Me contacter</button>
        </div>
      </form>
    </div>
    <div v-else class="validate">
      <div class="response">
        <p>Votre mail a bien été envoyé.</p>
        <span>J'essaie de vous répondre le plus rapidement possible, merci pour votre intérêt.</span>
      </div>

    </div>

  </div>
</template>
<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import DirectionArrows from '@/components/ArrowsDirection.vue'
import emailjs  from 'emailjs-com'


export default {
  name: 'Contact',
  props: ['position', 'sidebar', 'count'],
  components: {
    HelloWorld,
    DirectionArrows
  },
  data(){
    return{
      name:'',
      lastname:'',
      sujet:'',
      mail:'',
      message:'',
      isSend:false,
      errorMessage:null
    }
  },
  methods:{
    async sendMail(){
      let params={
        'from_name':this.name+" "+this.lastname,
        'subject':this.sujet,
        'message':this.message,
        'reply_to':this.mail
      }
   let response = await emailjs.send('service_e9bwzyr','template_sm964ro',params,'user_q7CrSbtpjORdWvoSTbHUn').then(function(resp){
    return {succes:true}
    },function(err){
      return {error:err.text}
    })
      if(response.succes)
        this.isSend = response.succes
      else
        this.errorMessage =response.error
    },
    validate(e){

        if(this.name && this.mail && this.sujet && this.message && this.lastname)
          this.sendMail()


      e.preventDefault()
    }


  },
}
</script>
<style>
#contact {
  height: 80%;
  width: 40%;
  order: 1;
  transition: .3s;

}

.form-container ,.validate{
  position: relative;
  z-index: 1;
  text-align: left;
  background: rgba(1, 7, 20, 0.31);
  padding: 20px;
  height: inherit;
}
.validate{
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.validate p{
  font-size:1.8em;
}

.form-container .label-group {
  margin: 20px;
  display: flex;
  align-items: center;
}

.form-container .label-group > * {
  flex: 1;
}

.form-container .label-group > input {
  background: transparent;
  border: none;
  border-bottom: 2px dashed #fff;

  color: #fff;
  letter-spacing: 2px;
  font-size: 1.5em;
}

.form-container .label-group > label {
  font-size: 1.5em;
}
.form-container .label-group textarea{
  margin-top:10px;
  background: rgba(1, 7, 20, 0.31);
  border: 1px solid rgba(0, 4, 10, 0.31);
  color:white;
  padding:10px;
}
.form-container .submit-group{
  display: flex;
}
.form-container .submit-group .btn{
  margin:auto;
  padding:20px 40px;
  background: rgba(1, 7, 20, 0.31);
  border: 1px solid rgba(0, 4, 10, 0.31);
  color:white;
  font-weight: bold;
  text-transform: uppercase;
  font-size:initial;
  transition: .3s;
}
.form-container .submit-group .btn:hover{
cursor: pointer ;
  background: var(--background);
  border: 1px solid rgba(0, 4, 10, 0.31);
  color:white;
  font-weight: bold;
  text-transform: uppercase;
  font-size:initial;
}
</style>
